<template v-show="!props.field.hidden">
  <div>
    <div>{{ field.label }}</div>

    <GenericFormLayout
      ref="fieldsLayoutRef"
      v-model="formData"
      :dense="dense"
      :errors="formErrors"
      :fields="fields"
      :rules="formRulesMap"
    />

    <MapFieldWrapper
      v-if="formData && (!formData.defined_by_coordinates || formData.defined_by_coordinates === undefined)"
      :center-address="formData"
      class="mt-2"
      :zoom="18"
    />

    <FormMapField
      v-if="formData.defined_by_coordinates"
      v-model:address="formData"
      class="mt-2"
      :zoom="18"
    />
  </div>
</template>

<script setup lang="ts">
import { GenericFormLayout } from '#components';

const props = defineProps<{
  field: FieldConfig
  modelValue?: Address
  errors?: string[]
  rules?: FormRule[]
  dense?: boolean
}>();

const emit = defineEmits(['update:modelValue']);

const { getAddressFormConfig } = useFieldConfigsAddress();
const fields = await getAddressFormConfig();

const fieldsLayoutRef = ref<InstanceType<typeof GenericFormLayout>>();

const {
  data: formData,
  rules: formRulesMap,
  errors: formErrors,
} = useSetupFormFromFields({
  fields,
  initialData: props.modelValue,
});

watch(formData, newData => {
  emit('update:modelValue', newData);
}, { deep: true });
</script>
